import ballIcon from "../../assets/icons/sections/ball.png";
import educationIcon from "../../assets/icons/sections/education.png";
import englishIcon from "../../assets/icons/sections/english.png";
import globeIcon from "../../assets/icons/sections/globe.png";
import groupIcon from "../../assets/icons/sections/group.png";
import shakeIcon from "../../assets/icons/sections/handshake.png";
import bulbIcon from "../../assets/icons/sections/lightbulb.png";
import medalIcon from "../../assets/icons/sections/medal.png";
import personIcon from "../../assets/icons/sections/person.png";
import suitcaseIcon from "../../assets/icons/sections/suitcase.png";

import styles from "./BoletimSection.module.css";

const ICONS = {
	person: personIcon,
	globe: globeIcon,
	medal: medalIcon,
	english: englishIcon,
	bulb: bulbIcon,
	suitcase: suitcaseIcon,
	ball: ballIcon,
	group: groupIcon,
	education: educationIcon,
	ventures: shakeIcon,
};

function BoletimSection({ children, title, icon, dark = false }) {
	return (
		<div className={styles.container}>
			<div className={styles.head}>
				<img
					src={ICONS[icon]}
					className={styles.icon}
					alt={`${icon}-icon`}
				/>
				<div className={styles.title}>{title}</div>
			</div>
			<div className={dark ? styles.darkCard : styles.lightCard}>
				{children}
			</div>
		</div>
	);
}

export default BoletimSection;
